
import TableList from "@components/templates/tablelist";
import { mapState,mapGetters } from 'vuex'
import { HttpInitWareSku, HttpWareSkuList } from '@/service/boss/allot';

export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true}
        };
    },
    methods: {
        ajaxRequest: HttpWareSkuList,
        interceptRequest(params){
            const search=params.search,createdAt=(search.GE_createdAt||"").split('~');
            search.GE_createdAt=createdAt[0];
            search.LE_createdAt=createdAt[1];
            return params;
        },
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "init":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{orgId: global.SYSID,list: params},
                        title: "批量初始化单仓SKU操作",
                        ajaxRequest:HttpInitWareSku
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id,parentId} = row;
            return [{
                label:'查看',
                show:true,
                params:{id,parentId},
                operate:'query'
            }]
        },
    },
    computed: {
        ...mapState('boss', ['accounts','products','vsgroup']),
        ...mapGetters('boss',['warehouses']),
        ToolsData(){
            return [
                {
                    name: "批量初始化",
                    operate: "init",
                    theme: "primary",
                    batch:true,
                }
            ]
        },
        SearchsData() {
            const  warehouses= this.warehouses.map((item) => {
                const {id,title,code}=item;
                return {
                    value: id,
                    label:`${title}(${code})`
                }
            }),
            products= this.products.map((item) => {
                const {id,name}=item;
                return {
                    value: id,
                    label:name
                }
            }),
            vsgroup=this.vsgroup.map((item) => {
                const {id,warehouseTitle,ruleName}=item;
                return {
                    value: id,
                    label:`${warehouseTitle}--${ruleName}`
                }
            });
            return  [
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'erpSku',
                    show:true,
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'lineId',
                    show:true,
                    options:products,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'orgWarehouseId',
                    show:true,
                    options:warehouses,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: "虚拟仓",
                    tag: 'vSelect',
                    key: 'EQ_stockVirtualGroupRuleItemId',
                    options:vsgroup,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: "可用库存",
                    tag: 'vInput',
                    key: 'CN_surfaceId',
                },
                {
                    label: "库存预留量",
                    tag: 'vInput',
                    key: 'CN_surfaceId',
                },
                {
                    label: "不可售数量",
                    tag: 'vInput',
                    key: 'CN_surfaceId',
                },
                {
                    label: "当前库存",
                    tag: 'vInput',
                    key: 'CN_surfaceId',
                },
                {
                    label: "在途库存",
                    tag: 'vInput',
                    key: 'CN_surfaceId',
                },
                {
                    label: "更新时间",
                    tag: 'vDatePicker',
                    key: 'CN_surfaceId',
                },
                
            ]
        },
        columns() {
            return  [{
                title: '操作',
                width: 70,
                render:this.getOperateNodes
            },
            {
                title: '项目',
                key: 'lineName',
            },
            {
                title: '仓库',
                key: 'orgWarehouseCode',
            },
            {
                title: '仓库产品编码',
                key: 'orgWarehouseCode',
            },
            {
                title: 'ERPSKU',
                key: 'sku',
            },
            {
                title: '可用库存',
                width: 120,
                key: 'sku',
                sortable: true,
            },
            {
                title: '库存预留量',
                width: 120,
                key: 'sku',
                sortable: true,
            },
            {
                title: '不可售数量',
                width: 120,
                key: 'sku',
                sortable: true,
            },
            {
                title: '当前库存',
                width: 120,
                key: 'sku',
                sortable: true,
            },
            {
                title: '在途库存',
                width: 120,
                key: 'sku',
                sortable: true,
            },
            {
                title: '币种',
                width: 100,
                key: 'sku',
                sortable: true,
            },
            {
                title: '单位库存成本',
                width: 140,
                key: 'sku',
                sortable: true,
            },
            {
                title: '库存总成本',
                width: 120,
                key: 'sku',
                sortable: true,
            },
            {
                title: 'DDP成本',
                width: 120,
                key: 'sku',
                sortable: true,
            },
            {
                title: '更新时间',
                width: 140,
                key: 'sku',
                sortable: true,
            },
        ];
        },
        
    },

};
